import type { DynamicPageProps } from '@/core/features/a-dynamic-page/dynamic-page-types';

import React from 'react';

import NotificationWrapper from '@/core/components/notification/notification-wrapper';
import {
    captureNativeAppBridgeMethod,
    triggerAppWebViewLoaded,
} from '@/core/features/native-app-bridge/native-app-bridge-service';
import { scrollToTop } from '@/core/features/scroll/scroll-service';
import PageComponentSwitchWrapper from '@/features/a-dynamic-page/components/page-component-switch-wrapper';
import MobileContentWrapper from '@/features/page-layouts/mobile/mobile-content-wrapper';
import MobileLayoutWrapper from '@/features/page-layouts/mobile/mobile-layout-wrapper';

export default function MobileLayout(props: DynamicPageProps) {
    const components = props.components;

    const headerTopComponents = components.filter((component) => component.meta.layoutPosition === 'header_top');
    const fullColComponents = components.filter((component) => component.meta.layoutPosition === 'full');
    const footerComponents = components.filter((component) => component.meta.layoutPosition === 'footer');

    const isBottomSheetWebView = props.ssrProps.layoutId === 'Mobile_BottomSheet_WebView_V1';

    React.useEffect(() => {
        if (!window.C24App || !isBottomSheetWebView) {
            return;
        }
        setTimeout(() => {
            triggerAppWebViewLoaded(props.ssrProps.ssrUrl);
        }, 100); // wait for final rendering of components

        // eslint-disable-next-line fp/no-mutation
        window.C24App.indiBottomSheet = {
            disableScrollLock: captureNativeAppBridgeMethod('disableScrollLock'), // not implemented, yet
            enableScrollLock: captureNativeAppBridgeMethod('enableScrollLock'), // not implemented, yet
            navigate: captureNativeAppBridgeMethod('navigate'), // not implemented, yet
            onBottomSheetChange: captureNativeAppBridgeMethod('onBottomSheetChange'), // not implemented, yet
            onStorageRead: captureNativeAppBridgeMethod('onStorageRead'), // not implemented, yet
            onUrlChange: captureNativeAppBridgeMethod('onUrlChange'), // not implemented, yet
            scrollToTop: () => {
                captureNativeAppBridgeMethod('scrollToTop')();
                scrollToTop();
            },
        };
    }, [isBottomSheetWebView, props.ssrProps.ssrUrl]);

    return (
        <div className={`min-height-100dvh ${isBottomSheetWebView ? 'user-select-none padding-top-10' : ''}`}>
            {headerTopComponents.length > 0 && (
                <div className={'flex-center-vertical'}>
                    <PageComponentSwitchWrapper
                        {...props}
                        components={headerTopComponents}
                    />
                </div>
            )}
            <MobileLayoutWrapper>
                <MobileContentWrapper isPageLoading={props.isPageLoading}>
                    {fullColComponents.length > 0 && (
                        <PageComponentSwitchWrapper
                            {...props}
                            components={fullColComponents}
                        />
                    )}
                </MobileContentWrapper>
                <NotificationWrapper />
            </MobileLayoutWrapper>
            {footerComponents.length > 0 && (
                <div className={'flex-center-vertical'}>
                    <PageComponentSwitchWrapper
                        {...props}
                        components={footerComponents}
                    />
                </div>
            )}
        </div>
    );
}
